module.exports = __webpack_public_path__ + "img/logo.e12d48cd.svg";